import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Sun, Moon } from 'lucide-react';
import { useThemeMode } from '../../contexts/ThemeModeContext';

// Mode state now lives in App.jsx (so it can also drive the MUI theme palette,
// not just the CSS data-theme attribute). This just reads/flips it via context.
const ThemeToggle = () => {
  const { mode, toggleMode } = useThemeMode();

  return (
    <Tooltip title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
      <IconButton onClick={toggleMode} size="small" sx={{ color: 'inherit' }}>
        {mode === 'light' ? <Moon size={20} /> : <Sun size={20} />}
      </IconButton>
    </Tooltip>
  );
};

// Export the initializer so the app can set data-theme before first paint (avoids
// a light flash on a dark-mode reload). App.jsx also syncs this via its effect.
export const initializeTheme = () => {
  const theme = localStorage.getItem('nvst-theme') || 'light';
  document.documentElement.setAttribute('data-theme', theme);
};

export default ThemeToggle;
